const stringToArrayBuffer = (value) => {
  const source = typeof value === 'string' ? value : '';
  const buffer = new ArrayBuffer(source.length);
  const ref = new Uint8Array(buffer);
  for (let i = 0; i < source.length; i++) {
    ref[i] = source.charCodeAt(i) & 0xff;
  }

  return buffer;
};

export default stringToArrayBuffer;



// WEBPACK FOOTER //
// ./src/utils/stringToArrayBuffer.js